import { Card } from 'antd';
import React, { FC } from 'react';
import { connect } from 'react-redux';
import {
	getAssetReplacementMarkupOnOriginalCost,
	getAssetReplacementThreshold,
} from '../../utils/assetUtils';
import { getCurrency, nullSafeGet } from '../../utils/DataAccessUtils';
import { withRouter } from 'react-router';
import { Form } from '@ant-design/compatible';
import { KeyValueDisplay } from '../key_value_display/KeyValueDisplay';

const AssetPurchasePrice: FC<any> = ({ asset, userType, currentUser }): React.ReactElement => {
	const currency = getCurrency({ location: nullSafeGet('location', asset) });

	const assetInfo = {
		...(asset.capitalisedCost
			? { 'Capitalized Cost': currency.format(asset.capitalisedCost) }
			: asset.originalPrice
			? { 'Purchase Price': currency.format(asset.originalPrice) }
			: {}),
		'Replacement Markup on Original Cost': `${
			getAssetReplacementMarkupOnOriginalCost(asset) * 100
		}%`,
		'Replacement Threshold': `${getAssetReplacementThreshold(asset) * 100}%`,
	};

	return null;
	/*
		<Card title={'Asset Replacement Information'}>
			<KeyValueDisplay keyWidth={120} keyValueStore={assetInfo} horizontal={false} />
		</Card>*/
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(AssetPurchasePrice)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(Form.create()(ComponentWithoutUserType));
